import styled from 'styled-components';
import { Text as TextComponent } from '../../text';
import { colors, fontWeights, fonts } from '../../../theme/styled';
import { text } from '../../../theme/typography';
import { backgroundUrl } from '../../../utils/rendering';


export const ListItem = styled.li`
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Text = styled(TextComponent)`
  ${text};
  font-family: ${fonts.smallFont};
  font-weight: ${fontWeights.normal};
  color: ${colors.white};
  font-size: 14px;
  line-height: 1.57;

  a, p {
    color: ${colors.white};
  }
`;

export const Image = styled.div`
  width: 32px;
  height: 32px;
  margin-right: 12px;
  background-image: ${backgroundUrl('image')};
  background-size: cover;
`;
